export default "__VITE_ASSET__trg9k9i6__"